<template>
  <section>
    <b-row class="mx-n50">
      <b-col
        v-for="catalogItem in catalogItems.items"
        :key="catalogItem.contentId"
        class="px-50 mb-1"
        sm="3"
      >
        <CatalogItem :item="catalogItem" />
      </b-col>
      <template v-if="catalogItems.loading">
        <b-col
          v-for="index in 10"
          :key="index"
          sm="3"
        >
          <CatalogItemSkeleton />
        </b-col>
      </template>
      <InfiniteLoading
        spinner="waveDots"
        @infinite="getNextPageCatalogItems"
      >
        <div slot="no-results" />
        <div slot="no-more" />
      </InfiniteLoading>
    </b-row>
    <b-card
      v-if="catalogItems.items.length===0"
      no-body
      class="p-3 empty-catalog-items"
    >
      <GjIcon
        size="64px"
        name="Grid"
      />
      <span class="mb-50">
        {{ catalogSetId === '0' ? $tk('ClientPortal.CatalogItems.ThisCatalogHasNoCatalogItems') : $tk('ClientPortal.CatalogItems.ThisCatalogSetHasNoCatalogItems') }}
      </span>
    </b-card>
  </section>
</template>

<script>
import CatalogsService from '@/api/client/catalogs.service'
import CatalogSetsService from '@/api/client/catalogSets.service'
import InfiniteLoading from 'vue-infinite-loading'
import notification from '@/mixins/toastification'
import GjIcon from '@gjirafatech/gjirafa-icons/Icon.vue'
import CatalogItem from './CatalogItem.vue'
import CatalogItemSkeleton from './CatalogItemSkeleton.vue'

export default {
  components: {
    CatalogItem,
    CatalogItemSkeleton,
    InfiniteLoading,
    GjIcon,
  },
  mixins: [notification],
  props: {
    // eslint-disable-next-line vue/require-default-prop
    catalogId: String,
    catalogSetId: {
      type: String,
      default: '0',
    },
  },
  data() {
    return {
      catalogItems: {
        items: [],
        page: 0,
        loading: true,
      },
    }
  },
  async mounted() {
    this.catalogItems.loading = true
    try {
      let items = this.catalogSetId === '0' ? await CatalogsService.getCatalogItems(this.catalogId, 0, this.$route.params.accountId) : await CatalogSetsService.getCatalogSetItems(this.catalogId, this.catalogSetId, 0)

      if (this.catalogSetId !== '0') {
        items = items.catalogItems
      }

      this.catalogItems.items = items
    } catch (err) {
      this.error(err.message)
    }
    this.catalogItems.loading = false
  },
  methods: {
    async getNextPageCatalogItems($state) {
      try {
        // eslint-disable-next-line no-plusplus
        let items = this.catalogSetId === '0' ? await CatalogsService.getCatalogItems(this.catalogId, ++this.catalogItems.page, this.$route.params.accountId) : await CatalogSetsService.getCatalogSetItems(this.catalogId, this.catalogSetId, ++this.catalogItems.page, this.$route.params.accountId)

        if (this.catalogSetId !== '0') {
          items = items.catalogItems
        }

        if (items.length === 0) {
          $state.complete()
        } else {
          this.catalogItems.items.push(...items)
          $state.loaded()
        }
      } catch (err) {
        this.error(err.message)
      }
    },
  },
}
</script>
<style lang="scss">
.empty-catalog-items{
  height: calc(100vh - 200px);
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
